<div class="col-md-6 offset-md-3 mt-5">
  <div class="navbar-header" style="background-color: whitesmoke; height: 20%;">
    <a class="" rel="home" href="#" title="">

    </a>
</div>
</div>


<div class="p-4" style="display: flex;
width: 900px;">
    <div class="container">
      <div class="card" style="width: 18rem;">
        <img class="card-img-top"  src="assets/images/header-1.png" alt="Card image cap">
        <div class="card-body">
          <h5 class="card-title">Online Cess payment</h5>
          <a  (click)=" cessModuleRedirect() " class="btn btn-primary">Click to Pay</a>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="card" style="width: 18rem;">
        <img class="card-img-top"  src="assets/images/header-1.png" alt="Card image cap">
        <div class="card-body">
          <h5 class="card-title">Online Fee payment</h5>
          <a (click)="feepaymentRedirect()" class="btn btn-primary">Click to Pay</a>
        </div>
      </div>
    </div>
</div>
